import { type FC, type ReactNode } from 'react';
import classnames from 'classnames';

import styles from '../styles/InputsWrapper.scss';
import dibsCss from 'dibs-css';

type Props = {
    children: ReactNode;
};

const InputsWrapper: FC<Props> = ({ children }) => (
    <div
        className={classnames(
            styles.gridTemplateColumns,
            dibsCss.inlineGrid,
            dibsCss.gapSmall,
            dibsCss.wFull,
            dibsCss.mbSmall
        )}
    >
        {children}
    </div>
);

export default InputsWrapper;
